import React from 'react';
import './App.css';
import Routing from './Routing';


function App() {
  return (
    <div>
      <Routing/>
    </div>
  );
}

export default App;
